export const BUTTON_WIDGET = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.ButtonWidgetElement';
